import React from 'react'
import styles from './styles.module.css'

function AddressRecordBusiness ({ record }) {
  return (
    <div className={styles.AddressRecordBusinessContainer}>
      <h1 className={styles.AddressRecordBusinessTitle}>
        {record?.address ? record.address : 'N/A'}
      </h1>

      <p className={styles.AddressRecordBusinessDetails}>
        {record?.city}
        {record?.city && record?.province ? ', ' : ''}
        {record?.province}
        {(record?.city || record?.province) && record?.postalCode ? ' ' : ''}
        {record?.postalCode}
      </p>
    </div>
  )
}

export default AddressRecordBusiness
